import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponent } from '../../icons/icon.component';
import { CommonModule } from '@angular/common';

interface TabData {
  module: string;
  summary_parsed: {
    summary: any,
    anomalies: any[],
    insights: any[],
    playbook: any[],
    actions: any[]
  },
  summary: any,
  anomalies: any[],
  insights: any[],
  playbook: any[],
  actions: any[]
}

interface infoModalData {
  module?: string;
  summary_parsed: {
    summary: any,
    anomalies: any[],
    insights: any[],
    playbook: any[],
    actions: any[]
  },
  summary: any,
  anomalies: any[],
  insights: any[],
  playbook: any[],
  actions: any[]
}

@Component({
  selector: 'app-ai-summary-modal',
  imports: [CommonModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ai-summary-modal.component.html'
})
export class AiSummaryModalComponent {

  severityClasses: any = {
    high: 'bg-red-100 text-red-800 dark:bg-red-700 dark:text-red-100',
    med: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-700 dark:text-yellow-100',
    low: 'bg-green-100 text-green-800 dark:bg-green-700 dark:text-green-100'
  };

  public data = inject(MAT_DIALOG_DATA) as infoModalData[];
  public _dialogRef = inject(MatDialogRef);

  activeTabIndex: number = 0;

  get hasMultipleTabs(): boolean {
    return !!this.data && this.data.length > 1;
  }

  get activeTab(): TabData | infoModalData {
    if (this.hasMultipleTabs && this.data) {
      return this.data[this.activeTabIndex];
    }
    return this.data[this.activeTabIndex];
  }

  // new code for get data from active tab

  get summary() {
    return this.activeTab?.summary_parsed?.summary
      || this.activeTab?.summary
      || null;
  }


  get insights() {
    const parsed = this.activeTab?.summary_parsed?.insights;
    const fallback = this.activeTab?.insights;

    return Array.isArray(parsed) && parsed.length
      ? parsed
      : Array.isArray(fallback) && fallback.length
        ? fallback
        : [];
  }


  get playbook() {
    const parsed = this.activeTab?.summary_parsed?.playbook;
    const fallback = this.activeTab?.playbook;

    return Array.isArray(parsed) && parsed.length
      ? parsed
      : Array.isArray(fallback) && fallback.length
        ? fallback
        : [];
  }


  get actions() {
    const parsed = this.activeTab?.summary_parsed?.actions;
    const fallback = this.activeTab?.actions;

    return Array.isArray(parsed) && parsed.length
      ? parsed
      : Array.isArray(fallback) && fallback.length
        ? fallback
        : [];
  }

  get anomalies() {
    const parsed = this.activeTab?.summary_parsed?.anomalies;
    const fallback = this.activeTab?.anomalies;

    return Array.isArray(parsed) && parsed.length
      ? parsed
      : Array.isArray(fallback) && fallback.length
        ? fallback
        : [];
  }


  selectTab(index: number): void {
    this.activeTabIndex = index;
  }

}
